import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "HeroBanner",
    component: () => (__SERVER__ ? require("./hero-banner-view") : import("./hero-banner-view"))
});

export default definition;
